import { useRecoilValue } from 'recoil'
import styled from '@emotion/styled'
import dateFormat from 'dateformat'
import { Typography } from '@mui/material'
import { CheckCircle } from '@emotion-icons/fa-solid/CheckCircle'
import { Colors, Shapes } from 'src/components/theme'
import { getStripeEpoch } from 'src/utils/date-utils'
import { CREADIT_CARDS_NAMES } from 'src/constants/credit-cards'

import * as paymentsAtoms from 'src/atoms/payments'
import * as billingAtoms from 'src/atoms/billing'

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Shapes.spacing[6]}px;
`
const PlanCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: ${Shapes.spacing[2]}px;
  padding: ${Shapes.spacing[4]}px;
  background-color: ${Colors.bgMedium};
  border-radius: ${Shapes.borderRadius}px;
`
const PaymentDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Shapes.spacing[2]}px;
`
const PaymentDetailsRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${Shapes.spacing[2]}px;
  p {
    flex: 1;
  }
`
const PaymentMethodWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${Shapes.spacing[2]}px;
  p {
    display: flex;
    align-items: center;
    gap: ${Shapes.spacing[1]}px;
  }
`
const PaymentMethodCard = styled.div`
  display: flex;
  align-items: center;
  gap: ${Shapes.spacing[1]}px;
`

type SubscriptionPaymentSucessfulProps = {
  date: number
  paidAmount: number
}
export const SubscriptionPaymentSucessful = (props: SubscriptionPaymentSucessfulProps) => {
  const { date, paidAmount } = props
  const selectedPlan = useRecoilValue(paymentsAtoms.selectedPaymentPlan)
  const selectedPlanPrice = useRecoilValue(paymentsAtoms.selectedPaymentPlanPrice)
  const defaultPaymentMethod = useRecoilValue(billingAtoms.defaultPaymentMethod)

  if (!defaultPaymentMethod || !selectedPlan || !selectedPlanPrice) {
    return null
  }

  return (
    <Content>
      <Typography variant="header2" color={Colors.textBlack} textAlign="center">
        Payment Successful
      </Typography>
      <PlanCard>
        <CheckCircle size={24} color={Colors.tealDark} />
        <Typography variant="header1" color={Colors.textBlack}>
          {paidAmount}
        </Typography>
        <Typography variant="title2l" color={Colors.textLight}>
          {selectedPlan.name} - {selectedPlanPrice.recurring?.interval === 'month' ? 'Monthly' : 'Annual'} Plan
        </Typography>
      </PlanCard>
      <PaymentDetails>
        <PaymentDetailsRow>
          <Typography variant="title2m" color={Colors.textDark}>
            Payment Date
          </Typography>
          <Typography variant="title2m" color={Colors.textLight} textAlign="right">
            {dateFormat(getStripeEpoch(date), 'mmmm dd, yyyy')}
          </Typography>
        </PaymentDetailsRow>
        <PaymentDetailsRow>
          <Typography variant="title2m" color={Colors.textDark}>
            Payment Method
          </Typography>
          <PaymentMethodWrapper>
            <Typography textTransform="capitalize" variant="title2m" color={Colors.textLight} textAlign="right">
              {defaultPaymentMethod?.brand !== 'unknown' && (
                <img src={`/credit-cards/${defaultPaymentMethod?.brand}.png`} height={24} />
              )}
              {CREADIT_CARDS_NAMES[defaultPaymentMethod.brand]}
            </Typography>
            <PaymentMethodCard>
              <Typography variant="title2m" color={Colors.textLight} textAlign="right">
                {`•••• ${defaultPaymentMethod?.last4}`}
              </Typography>
            </PaymentMethodCard>
          </PaymentMethodWrapper>
        </PaymentDetailsRow>
      </PaymentDetails>
    </Content>
  )
}
